import React from 'react';
import Container from 'react-bootstrap/Container';

const WhoAreWe = () => {
    return (
        <div className='section-separator'>
        <Container className='px-4'>
            <div className='my-5'>
                <h2 className='display-5 fw-bold text-white text-center fw-bold about-us-page-text mb-3'>QUEM SOMOS?</h2>
                <div className='col-lg-5 mx-auto'>
                    <p className='mb-4 text-justify about-us-page-text lead'>Nascemos da convicção de que os jovens não são apenas o futuro, mas também o presente e que o seu envolvimento ativo na sociedade é essencial para gerar mudanças reais.
                        </p>
                        <p className='mb-4 text-justify about-us-page-text lead'>A Youth 4 Change (Y4C) é uma associação juvenil que acredita no potencial transformador dos jovens. 
    Trabalhamos para garantir que a juventude tem acesso às ferramentas, oportunidades e conhecimentos necessários para construir um futuro mais sustentável, inclusivo e participativo. 
    Por isso, promovemos iniciativas que capacitam jovens a tornarem-se líderes, inovadores e cidadãos conscientes, capazes de impactar positivamente as suas comunidades e além-fronteiras.</p>
                </div>
                
            </div>
        </Container>
            
    </div>
    );
}

export default WhoAreWe;